import { render } from "./BerichtFoerderantrag.pug?vue&type=template&id=12c86523&lang=pug"
import script from "./BerichtFoerderantrag.js?vue&type=script&lang=js"
export * from "./BerichtFoerderantrag.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__